<template>
  <a-spin
    tip="Your document is being processed, do not leave this page!"
    :spinning="loading.page"
  >
  <a-config-provider :locale="getLocalConfigProvider()">
    <div class="wrapper">
      <div class="wrapper-header">
        <span>
          <a-icon type="wallet" class="margin-right-small" />
          Monitoring Compensation
        </span>
        <a-button @click="handleReload" size="small" icon="reload"></a-button>
      </div>
      <div class="wrapper-body">
        <a-card>
          <a-row :gutter="12">
            <a-col :xs="{ span: 24 }" :lg="{ span: 21 }">
              <a-input-search v-model="search" @change="moresearch" placeholder="Quick Search" />
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 3 }">
              <div style="width:100%;text-align:left"
              >
                <a-badge :dot="showbadge">
                  <a-button
                    :icon="advancedsearch == 'display:none' ? 'down' : 'up'"
                    @click="handleshowMore"
                    class="m-width-full"
                    :class="getScreen ? 'margin-top m-width-full' : 'm-width-full'"
                    >{{
                      advancedsearch == "display:none" ? "More" : "Less"
                    }}</a-button
                  >
                </a-badge>
              </div>
            </a-col>
          </a-row>
          <a-row :style="advancedsearch" :gutter="8">
            <a-col :xs="{ span: 24 }" :lg="{ span: 6 }" class="margin-top">
              <div class="m-form-item-wrapper">
                <label>Transaction Date</label>
                <a-range-picker
                  :placeholder="['Start Date', 'End Date']"
                  v-model="transDt"
                  @change="moresearch"
                  :format="getDefaultDateFormat"
                  allowClear
                />
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 6 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>SPT Periode</label>
                  <a-month-picker
                    placeholder="Choose SPT Periode"
                    v-model="sptperiode"
                    @change="moresearch"
                    :format="'MM-YYYY'"
                    allowClear
                  />
                </div>
              </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 6 }" class="margin-top">
              <div class="m-form-item-wrapper">
                <label>Type SPT</label>
                <a-select
                  placeholder="Choose Type SPT ... "
                  v-model="type_spt"
                  @change="moresearch"
                  class="width-full"
                  initialValue="undefined"
                  allowClear
                >
                  <a-select-option value="ppn">PPN</a-select-option>
                    <a-select-option value="pph_21">PPh 21</a-select-option>
                    <a-select-option value="pph_unifikasi">PPh Unifikasi</a-select-option>
                    <a-select-option value="pph_tahunan">PPh Tahunan</a-select-option>
                </a-select>
              </div>
            </a-col>
            <a-col :xs="{ span: 24 }" :lg="{ span: 6 }" class="margin-top">
              <div class="m-form-item-wrapper">
                <label>Type Compensation</label>
                <a-select
                  placeholder="Chose Type Compensation... "
                  v-model="type_compensation"
                  @change="moresearch"
                  allowClear
                  class="width-full"
                  initialValue="all"
                >
                  <a-select-option value="kompensasi"> Kompensasi </a-select-option>
                  <a-select-option value="PBK"> PBK </a-select-option>
                </a-select>
              </div>
            </a-col>
          </a-row>
              <!-- <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="transactionDt"
                    :format="getDefaultDateFormat"
                    allowClear
                  />
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>Tax Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="taxDt"
                    :format="getDefaultDateFormat"
                    allowClear
                    :disabled="preparedToGenerate.dis_TaxDt"
                  />
                </div>
              </a-col>
            </a-row>
            <a-row :gutter="8">
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>Type</label>
                  <a-select
                    placeholder="Ex: All Type ... "
                    v-model="type"
                    class="width-full"
                    initialValue="all"
                  >
                    <a-select-option value="all">All Type</a-select-option>
                    <a-select-option value="account_pay"> ACCOUNT PAY </a-select-option>
                    <a-select-option value="account_receivable"> ACCOUNT RECEIVABLE </a-select-option>
                    <a-select-option value="account_receivable_sales_contract"> ACCOUNT RECEIVABLE SALES CONTRACT </a-select-option>
                    <a-select-option value="adendum"> ADENDUM </a-select-option>
                    <a-select-option value="other_income"> OTHER INCOME </a-select-option>
                    <a-select-option value="pi"> PI </a-select-option>
                    <a-select-option value="po"> PO </a-select-option>
                    <a-select-option value="tax_manual"> TAX MANUAL </a-select-option>
                    <a-select-option value="tax_verification"> TAX VERIFICATION </a-select-option>
                    <a-select-option value="wo"> WO </a-select-option>
                  </a-select>
                </div>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <a-row :gutter="12">
                  <a-col :xs="{ span: 24 }" :lg="{ span: 14 }">
                  <div class="m-form-item-wrapper">
                    <label>Tax Type</label>
                    <a-select
                      placeholder="Ex: All Type ... "
                      v-model="typetransaction"
                      class="width-full"
                      initialValue="all"
                      :disabled="preparedToGenerate.dis_TaxDt"
                    >
                      <a-select-option value="all">All Tax Type</a-select-option>
                      <a-select-option
                        v-for="item in getType_tax"
                        :key="item.value"
                        :value="item.value"
                      >
                        {{ item.text }}
                      </a-select-option>

                      <--a-select-option value="all">All transaction</--a-select-option>
                    <a-select-option value="PO">PO</a-select-option>
                    <a-select-option value="WO">WO</a-select-option>
                    <a-select-option v-if="tabs.active=='queue'" value="Adendum">Addendum</a-select-option>
                    <a-select-option value="Adendum">Adendum</a-select-option> --
                    </a-select>
                  </div>
                  </a-col>
                  <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
                    <div class="m-form-item-wrapper">
                      <label>SPT Generated</label>
                      <a-select
                        placeholder="Ex: All SPT ... "
                        v-model="isgenerateSPT"
                        class="width-full"
                        initialValue="all"
                        :disabled="preparedToGenerate.dis_TaxDt"
                      >
                        <a-select-option value="all">All SPT</a-select-option>
                        <a-select-option key="1" value="1">Yes</a-select-option>
                        <a-select-option key="0" value="0">No</a-select-option>
                      </a-select>
                    </div>
                    </a-col>
                </a-row>
              </a-col>
              <a-col :xs="{ span: 24 }" :lg="{ span: 8 }" class="margin-top">
                <div class="m-form-item-wrapper">
                  <label>Status Document</label>
                  <a-select
                    showSearch
                    v-model="stsDocument"
                    placeholder="Select Status Document"
                    class="width-full"
                    initialValue="all"
                    allowClear
                    :filterOption="filterOption"
                  >
                    <a-select-option value="all"
                      >All Status Document</a-select-option
                    >
                    <a-select-option value="yes"
                      >Document Complete</a-select-option
                    >
                    <a-select-option value="no"
                      >Document not Complete</a-select-option
                    >
                  </a-select>
                </div>
              </a-col>
            </a-row>
          </a-row>-->
        </a-card>
        <div class="bordered">
          <a-tabs
            class="custom-tabs"
            :activeKey="tabs.active"
            @change="handleTab"
          >
            <a-tab-pane key="need_process">
              <template slot="tab">
                <span>Need Process</span>&nbsp;
                <a-badge
                class="m-badge m-badge-small"
                :count="needProcess.length"
                :numberStyle="{ backgroundColor: 'red' }"
                v-if="needProcess.length > 0"
              >
              </a-badge>
              </template>
              <div class="wrapper-pertabs" style="height: 30px!important;justify-content: end!important;">
              <span >Total : {{ formatRupiah(totaltabs) }}</span>
              </div>
              <a-config-provider :locale="getLocalConfigProvider()">
              <a-table
                :rowKey="(record, index) => {
                      return index.toString();
                    }
                    "
                size="small"
                bordered
                :scroll="{ x: 600 }"
                :columns="columns.needProcess"
                :dataSource="needProcess"
                :loading="tabs.loading"
                :pagination="pagination"
                :rowClassName="(record, index) => { return record.check == '1' ? 'selectedRow' : '' }"
              >
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{
                    (pagination.page - 1) * pagination.pageSize + index + 1
                  }}</span>
                </template>
                <template slot="no_trans" slot-scope="data">
                  <a @click="goToLink(data.spt_id, data.jns_pajak_pemakaian)">{{ data.spt_no }}</a>
                </template>
                <template slot="dtTlc" slot-scope="data">
                  <span>{{ moment(data.create_dt).format("DD-MM-YYYY") }}</span><br/>
                  <span>{{ data.tlc_create }}</span>
                </template>
                <template slot="sptmasa" slot-scope="data">
                  <span>{{ data.spt_masa_label }}</span>
                </template>
                <template slot="sptvalue" slot-scope="data">
                  <CurrencyJustified
                    :currencyValue="'IDR'"
                    :valueNumber="data.spt_value"
                  />
                </template>
                <template slot="aksi" slot-scope="text, data">
                    <a-button
                      @click="handleCreate(data)"
                      icon="plus"
                      :loading="loading.edit && loading.key == data.spt_id"
                      type="primary"
                    >Allocate</a-button>
                </template>
              </a-table>
              </a-config-provider>
            </a-tab-pane>
            <a-tab-pane key="list_kompensasi">
              <template slot="tab">
                <span>List Compensation</span>&nbsp;
                <!-- <a-badge
              class="m-badge m-badge-small"
              :count="needProcess.length"
              :numberStyle="{ backgroundColor: 'red' }"
              v-if="needProcess.length > 0"
            >
            </a-badge> -->
              </template>
              <div class="wrapper-pertabs" style="height: 30px!important;justify-content: end!important;">
              <span >Total : {{ formatRupiah(totaltabs) }}</span>
              </div>
              <a-config-provider :locale="getLocalConfigProvider()">
              <a-table
                :rowKey="(record, index) => {
                      return index.toString();
                    }
                    "
                size="small"
                bordered
                :scroll="{ x: 600 }"
                :columns="columns.list"
                :dataSource="listcompensation"
                :loading="tabs.loading"
                :pagination="pagination"
                :rowClassName="(record, index) => { return record.check == '1' ? 'selectedRow' : '' }"
              >
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{
                    (pagination.page - 1) * pagination.pageSize + index + 1
                  }}</span>
                </template>
                <template slot="no_trans" slot-scope="data">
                  <a @click="goToLink(data.spt_id, data.jns_pajak_pemakaian)">{{ data.spt_no }}</a>
                </template>
                <template slot="dtTlc" slot-scope="data">
                  <span>{{ moment(data.create_dt).format("DD-MM-YYYY") }}</span><br/>
                  <span>{{ data.tlc_create }}</span>
                </template>
                <template slot="sptmasa" slot-scope="data">
                  <span>{{ data.spt_type_label }}</span><br/>
                  <span>{{ data.spt_masa_label }}</span>
                </template>
                <template slot="sptvalue" slot-scope="data">
                  <CurrencyJustified
                    :currencyValue="'IDR'"
                    :valueNumber="data.spt_value"
                  />
                </template>
                <template slot="sptused" slot-scope="data">
                  <span>{{ data.jns_pajak_pemakaian_label }}</span><br/>
                  <span>{{ data.masa_pajak_pemakaian_label }}</span>
                </template>
                <template slot="comptype" slot-scope="data">
                  <span>{{ data.jns_kompensasi }}</span>
                </template>
                <template slot="aksi" slot-scope="text, data">
                  <a-button-group>
                    <a-button
                      @click="handleEdit(data)"
                      icon="edit"
                      :loading="loading.edit && loading.key == data.spt_id"
                      type="default"
                    ></a-button>
                    <a-button
                      @click="handleDelete(data.kompensasi_id)"
                      icon="delete"
                      :loading="loading.delete && loading.key == data.kompensasi_id"
                      type="danger"
                    ></a-button>
                  </a-button-group>
                </template>
              </a-table>
              </a-config-provider>
            </a-tab-pane>
            <a-tab-pane key="realisasi_kompensasi">
              <template slot="tab">
                <span>Compensation Realization</span>&nbsp;
                <!-- <a-badge
            class="m-badge m-badge-small"
            :count="needProcess.length"
            :numberStyle="{ backgroundColor: 'red' }"
            v-if="needProcess.length > 0"
          >
          </a-badge> -->
              </template>
              <div class="wrapper-pertabs" style="height: 30px!important;justify-content: end!important;">
                <span >Total : {{ formatRupiah(totaltabs) }}</span>
                </div>
              <a-config-provider :locale="getLocalConfigProvider()">
              <a-table
                :rowKey="(record, index) => {
                      return index.toString();
                    }
                    "
                size="small"
                bordered
                :scroll="{ x: 600 }"
                :columns="columns.realize"
                :dataSource="realizecompensation"
                :loading="tabs.loading"
                :pagination="pagination"
                :rowClassName="(record, index) => { return record.check == '1' ? 'selectedRow' : '' }"
              >
                <template slot="nomor" slot-scope="text, data, index">
                  <span>{{
                    (pagination.page - 1) * pagination.pageSize + index + 1
                  }}</span>
                </template>
                <template slot="no_trans" slot-scope="data">
                  <a @click="goToLink(data.spt_id, data.jns_pajak_pemakaian)">{{ data.spt_no }}</a>
                </template>
                <template slot="dtTlc" slot-scope="data">
                  <span>{{ moment(data.create_dt).format("DD-MM-YYYY") }}</span><br/>
                  <span>{{ data.tlc_create }}</span>
                </template>
                <template slot="sptmasa" slot-scope="data">
                  <span>{{ data.spt_type_realisasi_label }}</span><br/>
                  <span>{{ data.spt_masa_realisasi_label }}</span>
                </template>
                <template slot="sptvalue" slot-scope="data">
                  <CurrencyJustified
                    :currencyValue="'IDR'"
                    :valueNumber="data.spt_value"
                  />
                </template>
                <template slot="sptused" slot-scope="data">
                  <span>{{ data.jns_pajak_pemakaian_label }}</span><br/>
                  <span>{{ data.masa_pajak_pemakaian_label }}</span>
                </template>
                <template slot="comptype" slot-scope="data">
                  <span>{{ data.jns_kompensasi }}</span>
                </template>
                <template slot="comreal" slot-scope="data">
                  <a @click="handleNoRealisasi(data.spt_id_realisasi, data.spt_type_realisasi)">{{ data.spt_no_realisasi }}</a><br/>
                  <span>{{ data.spt_type_realisasi_label }} || {{ data.spt_masa_realisasi_label }}</span>
                </template>
                <template slot="aksi" slot-scope="text, data">
                    <a-button
                      @click="handleManifest(data)"
                      icon="eye"
                      :loading="loading.manifest && loading.key == data.kompensasi_id"
                      type="primary"
                    >Manifest</a-button>
                </template>
              </a-table>
              </a-config-provider>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>

    </div>
  </a-config-provider>
  <Modal v-if="modal.visible"
  :visible="modal.visible"
  :title="modal.title"
  :id_spt="modal.id_spt"
  :mode= "modal.mode"
  :data= "modal"
  />
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import GlobalMethod from "@/mixins/GlobalMethod";
import Modal from "./Modal.vue";
import _ from "lodash";

export default {
  name: "kompensasi",
  mixins: [CurrencyFormat, HandleRoute, GlobalMethod],
  components: {
    Modal,
  },
  data() {
    const columns = {
      needProcess: [
        {
          title: "#",
          key: "nomor",
          align: "center",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "No",
          key: "no",
          scopedSlots: { customRender: "no_trans" },
          width: 250,
        },
        {
          title: "Date / TLC",
          key: "dtTlc",
          align: "center",
          scopedSlots: { customRender: "dtTlc" },
          width: 100,
        },
        {
          title: "SPT Masa",
          key: "sptmasa",
          align: "center",
          scopedSlots: { customRender: "sptmasa" },
          width: 200,
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          width: 250,
        },
        {
          title: "SPT Value",
          key: "sptvalue",
          scopedSlots: { customRender: "sptvalue" },
          width: 200,
        },
        {
          title: "Action",
          fixed: "right",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "aksi" },
        },
      ],
      list: [
        {
          title: "#",
          key: "nomor",
          align: "center",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "No",
          key: "no",
          scopedSlots: { customRender: "no_trans" },
          width: 250,
        },
        {
          title: "Date / TLC",
          key: "dtTlc",
          align:"center",
          scopedSlots: { customRender: "dtTlc" },
          width: 100,
        },
        {
          title: "SPT Masa",
          key: "sptmasa",
          align: "center",
          scopedSlots: { customRender: "sptmasa" },
          width: 200,
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          width: 250,
        },
        {
          title: "SPT Value",
          key: "sptvalue",
          scopedSlots: { customRender: "sptvalue" },
          width: 200,
        },
        {
          title: "SPT Used",
          key: "sptused",
          align: "center",
          scopedSlots: { customRender: "sptused" },
          width: 200,
        },
        {
          title: "Compensation Type",
          key: "comptype",
          align: "center",
          scopedSlots: { customRender: "comptype" },
          width: 150,
        },
        {
          title: "Action",
          fixed: "right",
          align: "center",
          width: 80,
          scopedSlots: { customRender: "aksi" },
        },
      ],
      realize: [
        {
          title: "#",
          key: "nomor",
          align: "center",
          scopedSlots: { customRender: "nomor" },
          width: 50,
        },
        {
          title: "No",
          key: "no",
          scopedSlots: { customRender: "no_trans" },
          width: 250,
        },
        {
          title: "Date / TLC",
          key: "dtTlc",
          align: "center",
          scopedSlots: { customRender: "dtTlc" },
          width: 100,
        },
        {
          title: "SPT Masa",
          key: "sptmasa",
          align: "center",
          scopedSlots: { customRender: "sptmasa" },
          width: 200,
        },
        {
          title: "Description",
          key: "description",
          dataIndex: "description",
          width: 250,
        },
        {
          title: "SPT Value",
          key: "sptvalue",
          scopedSlots: { customRender: "sptvalue" },
          width: 200,
        },
        {
          title: "SPT Used",
          key: "sptused",
          align: "center",
          scopedSlots: { customRender: "sptused" },
          width: 200,
        },
        {
          title: "Compensation Type",
          key: "comptype",
          align: "center",
          scopedSlots: { customRender: "comptype" },
          width: 150,
        },
        {
          title: "Compensation Realization",
          key: "comreal",
          scopedSlots: { customRender: "comreal" },
          width: 250,
        },
        {
          title: "Action",
          fixed: "right",
          align: "center",
          width: 120,
          scopedSlots: { customRender: "aksi" },
        },
      ],
    };
    return {
      columns,
      loading: {
        page: false,
        key: "",
        edit: false,
        delete: false,
        modal: false,
        manifest: false,
      },
      search: undefined,
      advancedsearch: "display:none",
      transDt: undefined,
      type_spt: undefined,
      type_compensation: undefined,
      sptperiode: undefined,
      tabs: {
        active: "need_process",
        loading: false,
      },
      needProcess: [],
      needProcess_ori: [],
      listcompensation: [],
      listcompensation_ori: [],
      realizecompensation: [],
      realizecompensation_ori: [],
      pagination: {
        onChange: (page) => {
          this.pagination.page = page;
        },
        page: 1,
        pageSize: 10,
        size: "small",
      },
      modal: {
        visible: false,
        title: "",
        id_spt: null,
      }
    }
  }, 
  beforeCreate() {
  },
  mounted() {
    Event.$on("closemodal", this.closeModals);
    Event.$on("reload", this.handleReload);
    this.handleReload()
  },
  beforeDestroy() {
    Event.$off("closemodal", this.closeModals);
    Event.$off("reload", this.handleReload);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    showbadge() {
      let result = false;
      if ((this.transDt && this.transDt.length > 0)
        || (this.type_compensation) || (this.type_spt) || this.sptperiode)
        result = true;
      return result;
    },
    totaltabs() {
      let hasil = 0;
      if (this.tabs.active == "need_process") {
        hasil = _.sumBy(this.needProcess_ori, item => Number(item.spt_value)); 
      } else if (this.tabs.active == "list_kompensasi") {
        hasil = _.sumBy(this.listcompensation_ori, item => Number(item.spt_value));
      } else if (this.tabs.active == "realisasi_kompensasi") {
        hasil = _.sumBy(this.realizecompensation_ori, item => Number(item.spt_value));
      }
      return hasil;
    }
  },
  created() {
  },
  methods: {
    moment,
    closeModals(val) {
      this.modal.visible = val;
    },
    async handleReload() {
      this.tabs.loading = true;
      await this.asyncAxiosGet("kompensasi", this.getAuth, {
        tlc: this.getAuth.username,
        tab: this.tabs.active
      })
        .then((res) => {
        if (this.tabs.active=="need_process") {
          this.needProcess = res.data;
          this.needProcess_ori = res.data;
        }

        if (this.tabs.active == "list_kompensasi") {
          this.listcompensation = res.data;
          this.listcompensation_ori = res.data;
        }

        if (this.tabs.active == "realisasi_kompensasi") {
          this.realizecompensation = res.data;
          this.realizecompensation_ori = res.data;
        }

        this.tabs.loading = false;
      })
      .catch((err) => {
        this.tabs.loading = false;
        let responses = Object.assign({}, err.response.data);
        this.displayMessageValue("error-other", responses.message);
      });
    },
    handleshowMore() {
      if (this.advancedsearch == "display:none") {
        this.advancedsearch = "display:block";
      } else {
        this.advancedsearch = "display:none";
      }
    },
    resetSearch() {
      this.search = undefined;
    },
    handleTab(val) {
      this.tabs.active = val;
      this.resetSearch();
      // if (val === "needprocess") {
      //   this.listSuplier = this.needProcessSuplier;
      //   this.revisedStatus = "all";
      // } else if (val === "credittax") {
      //   this.listSuplier = this.quequeSuplier;
      // } else if (val === "release") {
      //   this.listSuplier = this.releaseSuplier;
      // }
      this.handleReload();
    },
    goToLink(spt_id,tipe) {
      const route = this.$router.resolve({
        name: "SPTManifest",
        params: { id: spt_id, tipe:tipe },
      });
      window.open(route.href, "_blank");
    },
    handleNoRealisasi(id, spt_type_realisasi) {
      const route = this.$router.resolve({
        name: "SPTManifest",
        params: { id: id , tipe: spt_type_realisasi },
      });
      window.open(route.href, "_blank");
    },
    viewDoc(url) {
      window.open(this.$serviceUrl + url, "_blank");
    },
    handleshowManifest(id) {
      this.loading.key = id;
      this.loading.manifest = true;
      this.$router.push({
        name: "SPTManifest",
        params: { id: id },
      });
      this.loading.key = "";
      this.loading.manifest = false;
    },
    handleEdit(data) {
      if (data.jns_kompensasi == "PBK") {
        this.loading.edit = true;
        this.loading.key = data.spt_id;
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: data.file_doc_pbk_path,
        })
          .then((response) => {
            let typefile = this.fileTypeFromUrl(data.file_doc_pbk_path);
            let file = this.dataURLtoFile(
              typefile + response.file_document_tax,
              data.file_doc_pbk
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.url = this.$serviceUrl + data.file_doc_pbk_path;
            this.modal.file_document_tax = [];
            this.modal.file_document_tax.push(file);

            this.modal.title = "Edit Allocation";
            this.modal.mode = "edit";
            this.modal.id_spt = data.spt_id;
            this.modal.create_dt = moment(data.create_dt);
            this.modal.kompensasi = data.jns_kompensasi;
            this.modal.kompensasi_id = data.kompensasi_id;
            this.modal.spt_masa = moment(data.spt_masa, "MM-YYYY");
            this.modal.value = data.spt_value;
            this.modal.spt_type = data.jns_pajak_pemakaian;
            this.modal.spt_periode = moment(data.masa_pajak_pemakaian, "MM-YYYY");
            this.modal.pbk_dt = moment(data.tgl_pbk, this.getStandartFormatDate);
            this.modal.pbk_no = data.no_pbk;
            this.modal.spt_no = data.spt_no;
            this.modal.spt_type_label = data.spt_type_label;
            this.modal.spt_masa_label = data.spt_masa_label;


            this.loading.edit = true;
            this.loading.key = "";
            this.modal.visible = true;
          })
          .catch((err) => {
            this.loading.edit = true;
            this.loading.key = "";
            console.log(err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      } else {
        this.modal.title = "Edit Allocation";
        this.modal.mode = "edit";
        this.modal.id_spt = data.spt_id;
        this.modal.create_dt = moment(data.create_dt);
        this.modal.kompensasi = data.jns_kompensasi;
        this.modal.kompensasi_id = data.kompensasi_id;
        this.modal.spt_masa = moment(data.spt_masa,"MM-YYYY");
        this.modal.value = data.spt_value;
        this.modal.spt_type = data.jns_pajak_pemakaian;
        this.modal.spt_periode = moment(data.masa_pajak_pemakaian, "MM-YYYY");
        this.modal.pbk_dt = moment(data.tgl_pbk, this.getStandartFormatDate);
        this.modal.pbk_no = data.no_pbk;
        this.modal.spt_no = data.spt_no;
        this.modal.spt_type_label = data.spt_type_label;
        this.modal.spt_masa_label = data.spt_masa_label;
        this.modal.visible = true;
      }
    },
    handleDelete(id) {
      const that = this;
      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.delete = true;
          that.loading.key = id;
          that.asyncAxiosDelete(
            "kompensasi",
            "application/json",
            that.getAuth,
            { kompensasi_id: id }
          )
          .then((response) => {
            that.loading.delete = false;
            that.loading.key = "";
            if (response.status && response.status == true) {
              that.displayMessageValue("success-other", response.message);
            } else {
              let responses = Object.assign({}, response);
              that.displayMessageValue("error-other", responses);
            }
            that.handleReload();
          })
          .catch((err) => {
            console.log(err);
            that.loading.delete = false;
            that.loading.key = "";
            let responses = Object.assign({}, err.response.data);
            that.displayMessageValue("error-other", responses.message);
          });
        },
        onCancel() { },
      });
    },
    intoList(type, value) {
      if (this.tabs.active == "need_process") {
        this.needProcess = value;
      } else if (this.tabs.active == "list_kompensasi") {
        this.listcompensation = value;
      } else {
        this.realizecompensation = value;
      }
    },
    moresearch() {
      let tempData = [];
      if (this.tabs.active == "need_process") {
        tempData = this.needProcess_ori;
      } else if (this.tabs.active == "list_kompensasi") {
        tempData = this.listcompensation_ori;
      } else {
        tempData = this.realizecompensation_ori;
      }

      if (this.transDt && this.transDt.length) {
        let startDt = moment(this.transDt[0]).format("YYYY-MM-DD");
        let endDt = moment(this.transDt[1]).format("YYYY-MM-DD");
        if (this.tabs.active == "need_process") {
          tempData = tempData.filter(
            (obj) => obj.date_create &&
              moment(obj.date_create).format("YYYY-MM-DD") >= startDt &&
              moment(obj.date_create).format("YYYY-MM-DD") <= endDt);
        } else if (this.tabs.active == "list_kompensasi") {
          tempData = tempData.filter(
            (obj) => obj.create_dt &&
              moment(obj.create_dt).format("YYYY-MM-DD") >= startDt &&
              moment(obj.create_dt).format("YYYY-MM-DD") <= endDt);
        } else {
          tempData = tempData.filter(
            (obj) => obj.create_dt &&
              moment(obj.create_dt).format("YYYY-MM-DD") >= startDt &&
              moment(obj.create_dt).format("YYYY-MM-DD") <= endDt);
        }
      }

      if (this.type_spt) {
        tempData = tempData.filter(
          (obj) => obj.spt_type && obj.spt_type.toLowerCase() == this.type_spt.toLowerCase()
        );
      }

      if (this.type_compensation) {
        tempData = tempData.filter(
          (obj) => obj.jns_kompensasi && obj.jns_kompensasi.toLowerCase() == this.type_compensation.toLowerCase()
        );
      }

      if (this.sptperiode) {
        tempData = tempData.filter(
          (obj) => obj.spt_masa &&
            moment(obj.spt_masa, "MM-YYYY").format("MM-YYYY") == moment(this.sptperiode).format("MM-YYYY")
        );
      }

      if (this.search) {
        tempData = tempData.filter(
          (obj) =>
            (obj.spt_no &&
              obj.spt_no
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.jns_kompensasi &&
              obj.jns_kompensasi
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.description &&
              obj.description
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.jns_pajak_pemakaian_label &&
              obj.jns_pajak_pemakaian_label
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.masa_pajak_pemakaian_label &&
              obj.masa_pajak_pemakaian_label
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.spt_masa_label &&
              obj.spt_masa_label
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.spt_type_label &&
              obj.spt_type_label
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0) ||
            (obj.tlc_create &&
              obj.tlc_create
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0)
        );
      }

      this.intoList(this.tabs.active, tempData);
    },
    handleCreate(data) {
      this.modal.visible = true;
      this.modal.title = "Allocate Compensation";
      this.modal.mode = "create";
      this.modal.id_spt = data.spt_id;
      this.modal.create_dt = undefined;
      this.modal.kompensasi = undefined;
      this.modal.value = data.spt_value;
      this.modal.spt_type = undefined;
      this.modal.spt_periode = null;
      this.modal.pbk_dt = null;
      this.modal.pbk_no = undefined;
      this.modal.spt_masa = moment(data.spt_masa, "MM-YYYY");
      this.modal.spt_no = data.spt_no;
      this.modal.spt_type_label = data.spt_type_label;
      this.modal.spt_masa_label = data.spt_masa_label;
    },
    handleManifest(data) {
      if (data.jns_kompensasi == "PBK") {
        this.loading.manifest = true;
        this.loading.key = data.kompensasi_id;
        this.asyncAxiosGet("main/base_64", this.getAuth, {
          path: data.file_doc_pbk_path,
        })
          .then((response) => {
            let typefile = this.fileTypeFromUrl(data.file_doc_pbk_path);
            let file = this.dataURLtoFile(
              typefile + response.file_document_tax,
              data.file_doc_pbk
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.url = this.$serviceUrl + data.file_doc_pbk_path;
            this.modal.file_document_tax = [];
            this.modal.file_document_tax.push(file);

            this.modal.title = "Manifest Compensation : #" + data.spt_no + " | " + data.spt_type_label + " " + data.spt_masa_label;
            this.modal.mode = "manifest";
            this.modal.id_spt = data.spt_id;
            this.modal.create_dt = moment(data.create_dt);
            this.modal.kompensasi = data.jns_kompensasi;
            this.modal.value = data.spt_value;
            this.modal.spt_type = data.jns_pajak_pemakaian;
            this.modal.spt_periode = moment(data.masa_pajak_pemakaian, "MM-YYYY");
            this.modal.pbk_dt = moment(data.tgl_pbk, this.getStandartFormatDate);
            this.modal.pbk_no = data.no_pbk;

            this.loading.manifest = true;
            this.loading.key = "";
            this.modal.visible = true;
          })
          .catch((err) => {
            this.loading.manifest = true;
            this.loading.key = "";
            console.log(err);
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error-other", responses.message);
          });
      } else {
        this.modal.visible = true;
        this.modal.title = "Manifest Compensation : #" + data.spt_no + " | " + data.spt_type_label + " " + data.spt_masa_label;
        this.modal.mode = "manifest";
        this.modal.id_spt = data.spt_id;
        this.modal.create_dt = moment(data.create_dt);
        this.modal.kompensasi = data.jns_kompensasi;
        this.modal.value = data.spt_value;
        this.modal.spt_type = data.jns_pajak_pemakaian;
        this.modal.spt_periode = moment(data.masa_pajak_pemakaian, "MM-YYYY");
        this.modal.pbk_dt = moment(data.tgl_pbk, this.getStandartFormatDate);
        this.modal.pbk_no = data.no_pbk;
      }
    }
  },
};
</script>

<style lang="less">
  .custom-tabs {
    .ant {
      &-tabs-bar {
        margin-bottom: 0;
      }
      &-tabs-content {
        flex: 1;
      }
    }
  }
  .ant-table-thead .ant-table-row-cell-break-word{
    text-align: center!important;
  }
  // .ant-select-dropdown--single{
  //   width:500px;
  //   overflow: visible!important;
  //   display:block!important
  // }
  // .ant-select-dropdown-menu{
  //   width:500px;
  //   overflow: visible;
  //   display:block;
  // }
  .bordered {
  border: 1px solid darken(white, 10);
}

.custom-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-item {
  display: flex;
  align-items: flex-start;
}

.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid darken(white, 10);
  &-header {
    height: 50px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border: 1px solid darken(white, 10);
    padding: @padding;
  }
  &-body {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  &-pertabs {
    height: 30px;
    background: darken(white, 2);
    display: flex;
    align-items: center;
    text-transform: capitalize;
    font-size: 1rem;
    font-weight: 500;
    color: @color-secondary;
    border: 1px solid darken(white, 10);
    padding: @padding;
    color: darken(red, 10)!important;
  }
}
</style>
